import classNames from 'classnames';
import { startTransition, type ReactNode } from 'react';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { FontAwesomeIcon } from '#src/atoms/icons/index.tsx';
import { iconChevronRight } from '#src/atoms/icons/system/iconChevronRight.ts';
import { Horizontal } from '#src/atoms/layout/flex/index.tsx';
import { BrandXXS } from '#src/atoms/typography/index.tsx';
import type { unitMapping } from '#src/lib/style.ts';

const BreadcrumbWrapper = styled(Horizontal)`
  width: fit-content;
  flex-wrap: wrap;
  &.withPadding {
    padding: var(--double-unit);
  }
`;

const StyledLink = styled(Link)<{ disabled: boolean }>`
  pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
`;

type Section = {
  name: ReactNode;
  to?: string;
};

type Props = {
  sections?: Section[];
  gap?: keyof typeof unitMapping;
  withPadding?: boolean;
};

export const Breadcrumb = ({
  sections,
  gap = 2,
  withPadding = false,
}: Props) => {
  const navigate = useNavigate();
  return (
    <BreadcrumbWrapper gap={gap} className={classNames({ withPadding })}>
      {sections?.map((section, index) => (
        <StyledLink
          key={section.name?.toString()}
          to={section.to ?? ''}
          disabled={index === sections.length - 1}
          onClick={e => {
            e.preventDefault();
            startTransition(() => {
              navigate(section.to ?? '');
            });
          }}
        >
          <Horizontal gap={gap}>
            {index !== 0 && (
              <FontAwesomeIcon icon={iconChevronRight} size="xs" />
            )}
            <BrandXXS>{section.name}</BrandXXS>
          </Horizontal>
        </StyledLink>
      ))}
    </BreadcrumbWrapper>
  );
};
